export const setPageMeta = (title, description) => {
  document.title = title;

  const setMeta = (selector, attr, value) => {
    let tag = document.head.querySelector(selector);
    if (!tag) {
      tag = document.createElement("meta");
      if (selector.includes("property=")) {
        tag.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
      } else {
        tag.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
      }
      document.head.appendChild(tag);
    }
    tag.setAttribute(attr, value);
  };

  setMeta('meta[name="description"]', "content", description);
  setMeta('meta[property="og:title"]', "content", title);
  setMeta('meta[property="og:description"]', "content", description);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", window.location.origin + window.location.pathname);
};
